import {Component} from 'panel';

import {registerMPElement} from '../../util/register-element';

import template from './index.jade';
import css from './index.styl?inline';

export default registerMPElement(
  `mp-drop-menu-pane`,
  class extends Component {
    static get attrsSchema() {
      return {
        header: `string`,
        'show-back-button': `boolean`,
      };
    }

    get config() {
      return {
        css,
        template,
        useShadowDom: true,

        helpers: {
          clickedBackButton: () => this.dispatchEvent(new CustomEvent(`back-click`)),
        },
      };
    }
  },
);
